import { useEffect, useState } from 'react';
import ProfileForm from './ProfileForm';
import ProfileList from './ProfileList';
import { PageTitle } from 'app/components';
import useAuth from 'app/hooks/useAuth';

function ProfileManagement() {
  const [refresh, setRefresh] = useState(false);

  const [edit, setEdit] = useState(false);
  const [profileId, setProfileId] = useState<number | null>(null);

  const { permissions: userPermissions } = useAuth();
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const permsProfile = userPermissions?.filter(pem => pem.resource.name == 'profile') ?? [];

    if (permsProfile.length > 0) {
      const profilePermissions: string[] = permsProfile?.map(pem => pem.action.name);
      setPermissions(profilePermissions)
    }
  },[]);

  const handleSave = () => {
    onRefresh()

    if (edit) {
      setEdit(false)
    }
  };

  const handleEdit = (id: number) => {
    setProfileId(id)
    setEdit(true)
  };

  const onRefresh = () => {
    setRefresh(!refresh);
  };

  const titles = [
    "Cadastro",
    "Perfil",
  ];

  return (
    <div>
      <PageTitle titles={titles} />
      <div className="container mx-auto tw-px-6 tw-pb-6">
        <ProfileForm 
          onSave={handleSave} 
          edit={edit}
          profileId={profileId}
          permissions={permissions}
        />
        <ProfileList
          handleEdit={handleEdit}
          refresh={refresh}
          onRefresh={onRefresh}
          permissions={permissions}
        />
      </div>
    </div>
  );
}

export default ProfileManagement;
